import Link from "next/link";
import type { ReactNode } from "react";

export type NavbarLogoProps = {
  children: ReactNode;
  href?: string;
};

const Logo = ({ children, href = "/" }: NavbarLogoProps) => {
  return <Link href={href}>{children}</Link>;
};

export default Logo;
